<template>
  <view
    class="border-tabbar-borderColor border-t-1px border-t-solid rounded-t-10px bg-tabbar-bg items-center text-tabbar-text flex fixed bottom-0 left-0 right-0 z-10 text-12px font-500 main-tabbar"
    style="box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.05)"
  >
    <template v-for="(item, index) in tabbarStore.tabbarList" :key="index">
      <view class="flex-1 text-center pb-5px" @click="tabbarStore.setCurrIndex(index)">
        <template v-if="index !== 2">
          <image
            v-if="index === tabbarStore.currIndex"
            :src="assetsConfig[item.icon].activeIcon"
            class="h-18px w-18px mx-auto"
            mode="aspectFit"
          />
          <image
            v-else
            :src="assetsConfig[item.icon].icon"
            class="h-18px w-18px mx-auto"
            mode="aspectFit"
          />
        </template>
        <image
          class="-mt-22px h-40px w-40px mx-auto"
          v-else
          :src="assetsConfig[item.icon].icon"
          mode="aspectFit"
        />
        <view
          class="mt-4px"
          :class="{
            'text-tabbar-activeText': index === tabbarStore.currIndex,
          }"
        >
          {{ $t(item.text) }}
        </view>
      </view>
    </template>
  </view>
  <!-- placeholder -->
  <view class="h-54px pb-safe box-content"></view>
</template>
<script setup lang="ts">
import TABBAR_HOME_ICON from '@/static/tabbar/tabbar1.png'
import TABBAR_HOME_ICON_ACTIVE from '@/static/tabbar/tabbar11.png'
import TABBAR_ACTIVITY_ICON from '@/static/tabbar/tabbar2.png'
import TABBAR_ACTIVITY_ICON_ACTIVE from '@/static/tabbar/tabbar22.png'
// import TABBAR_WALLET_ICON from '@/static/tabbar/qianbao.gif'
import TABBAR_WALLET_ICON from '@/static/tabbar/game.gif'
import TABBAR_RECOMMEND_ICON from '@/static/tabbar/tabbar5.png'
import TABBAR_RECOMMEND_ICON_ACTIVE from '@/static/tabbar/tabbar55.png'
import TABBAR_MY_ICON from '@/static/tabbar/tabbar4.png'
import TABBAR_MY_ICON_ACTIVE from '@/static/tabbar/tabbar44.png'
import { tabBar } from '@/pages.json'
import { useTabbarStore } from '@/store/tabbar'
const assetsConfig = {
  home: {
    icon: TABBAR_HOME_ICON,
    activeIcon: TABBAR_HOME_ICON_ACTIVE,
  },
  activity: {
    icon: TABBAR_ACTIVITY_ICON,
    activeIcon: TABBAR_ACTIVITY_ICON_ACTIVE,
  },
  wallet: {
    icon: TABBAR_WALLET_ICON,
    activeIcon: TABBAR_WALLET_ICON,
  },
  recommend: {
    icon: TABBAR_RECOMMEND_ICON,
    activeIcon: TABBAR_RECOMMEND_ICON_ACTIVE,
  },
  my: {
    icon: TABBAR_MY_ICON,
    activeIcon: TABBAR_MY_ICON_ACTIVE,
  },
}

const tabbarStore = useTabbarStore()

defineOptions({
  name: 'CustomTabbar',
})

onLoad(() => {
  // 解决原生 tabBar 未隐藏导致有2个 tabBar 的问题

  uni.hideTabBar()

})
</script>
<style lang="scss" scoped>
.main-tabbar {
  padding-top: 10px;
  padding-bottom: 0px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
